// Copyright (c) 2017, Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln
/**
 * GF(2^n) ; Extension Finite Field
 */
export class Gf2Ext {
    /**
     *
     */
    constructor(nth = 8, px = 0x011d) {
        this.nth = nth;
        this.px = px;
        this.expDict = [];
        this.lnDict = [this.NaN];
        let v = 1;
        this.numElements = Math.pow(2, nth); // 1 << nth
        this.mask = this.numElements - 1;
        this.expDict.length = this.mask;
        this.lnDict.length = this.numElements;
        for (let i = 0; i < this.mask; i++) {
            this.expDict[i] = v;
            this.lnDict[v] = i;
            v *= 2; // left shift 1. polynomial multipy by alpha(=2).
            if (v > this.mask) { // (v & ~this.mask)
                v = ((v ^ px) & this.mask) >>> 0;
            }
        }
    }
    /**
     * 53bits x & this.mask
     */
    bitMask(x) {
        x = Math.abs(x);
        const loX = (x & 0xffffffff) >>> 0;
        const hiX = (x - loX) / 4294967296;
        return ((hiX & this.maskHi) >>> 0) * 4294967296 + ((loX & this.maskLo) >>> 0);
    }
    /**
     *
     */
    checkGenerationResult() {
        for (let i = 1; i < this.numElements; i++) {
            if (this.lnDict[i] === void (0)) {
                return false;
            }
        }
        return true;
    }
    /**
     * order of this field
     */
    get MODULO() {
        return this.numElements;
    }
    /**
     *
     */
    get ZERO() {
        return 0;
    }
    /**
     *
     */
    get ONE() {
        return 1;
    }
    /**
     *
     */
    get ALPHA() {
        return 2;
    }
    /**
     *
     */
    get NaN() {
        return Number.NaN;
    }
    /**
     *
     */
    normalize(x) {
        return (x & this.mask) >>> 0;
    }
    /**
     *
     */
    isNaN(x) {
        return Number.isNaN(x);
    }
    /**
     *
     */
    eq(x, y) {
        return ((x & this.mask) >>> 0) === ((y & this.mask) >>> 0);
    }
    /**
     *
     */
    noteq(x, y) {
        return ((x & this.mask) >>> 0) !== ((y & this.mask) >>> 0);
    }
    /**
     *
     */
    neg(x) {
        return (x & this.mask) >>> 0;
    }
    /**
     *
     */
    inv(x) {
        x = (x & this.mask) >>> 0;
        return (x === 0) ? this.NaN :
            this.expDict[(this.mask - this.lnDict[x]) % this.mask];
    }
    /**
     *
     */
    add(x, y) {
        return ((x ^ y) & this.mask) >>> 0;
    }
    /**
     *
     */
    sub(x, y) {
        return ((x ^ y) & this.mask) >>> 0;
    }
    /**
     *
     */
    mul(x, y) {
        x = (x & this.mask) >>> 0;
        y = (y & this.mask) >>> 0;
        if (x === 0 || y === 0)
            return 0;
        return this.expDict[(this.lnDict[x] + this.lnDict[y]) % this.mask];
    }
    /**
     *
     */
    div(x, y) {
        x = (x & this.mask) >>> 0;
        y = (y & this.mask) >>> 0;
        if (y === 0)
            return this.NaN;
        if (x === 0)
            return 0;
        return this.expDict[(this.lnDict[x] + ((this.mask - this.lnDict[y]) % this.mask))
            % this.mask];
    }
    /**
     *
     */
    mod(x, y) {
        return (((y & this.mask) >>> 0) === 0) ? this.NaN : 0;
    }
    /**
     *
     */
    divmod(x, y) {
        return (((y & this.mask) >>> 0) === 0) ? {
            q: this.NaN,
            r: this.NaN,
            divisible: false
        } : {
            q: this.div(x, y),
            r: 0,
            divisible: true
        };
    }
    /**
     *
     */
    pow(a, x) {
        a = this.normalize(a);
        x = x % this.mask;
        if (a === 0) {
            return (x === 0) ? 1 : 0;
        }
        return (x >= 0)
            ? this.exp(this.ln(a) * x)
            : this.inv(this.exp(this.ln(a) * -x));
    }
    /**
     *
     */
    log(a, x) {
        // y = log(a,pow(a,y))
        //        // log(a,x) = ln(x) / ln(a)
        //        let p = this.ln(x);
        //        let q = this.ln(a);
        //        return this.div(p, q); // don't work
        const logDict = [this.NaN];
        for (let y = 0; y < this.mask; y++) {
            const v = this.pow(a, y);
            if (logDict[v] === void (0))
                logDict[v] = y;
        }
        const r = logDict[(x & this.mask) >>> 0];
        return r !== void (0) ? r : this.NaN;
    }
    /**
     *
     */
    exp(x) {
        return (x >= 0)
            ? this.expDict[x % this.mask]
            : this.inv(this.expDict[-x % this.mask]);
    }
    /**
     *
     */
    ln(x) {
        return this.lnDict[(x & this.mask) >>> 0];
    }
}
/**
 *
 */
export class Gf2e8Field extends Gf2Ext {
    /**
     *
     */
    constructor(px = 0x011d) {
        super(8, px);
    }
}
/**
 *
 */
export class Gf2e6Field extends Gf2Ext {
    /**
     *
     */
    constructor(px = 0x0043) {
        super(6, px);
    }
}
//# sourceMappingURL=Gf2Ext.js.map